define('viewmodels/modals/dialogs/QuestChooserDialog',['knockout'], function (ko) {

    var QuestChooserDialog = function(dialog, quests, questChooser, MessageAlert) {
        var self = this;

        self.dialog = dialog;
        self.availableQuests = quests.availableQuests;
        self.currentCampaignContent = quests.currentCampaignContent;
        self.selectedQuest = ko.observable();
        self.subscriptions = [];

        // In case quests aren't ready the first time, or set if it is
        self.subscriptions.push(self.availableQuests.subscribeAndExec(function(quests) {
            self.selectedQuest(quests[0]);
        }));

        self.questChooser = questChooser;

        self.showConfirmation = ko.observable(false);

        self.selectQuest = function(quest) {
            if (self.selectedQuest() === quest) {
                return;
            }
            self.selectedQuest(quest);
        };

        self.subscriptions.push(self.selectedQuest.subscribe(function() {
            self.showConfirmation(false);
        }));

        self.showOnlyFirstPrize = ko.observable(true);

        self.showQuestTermsDialog = function() {
            var dialogOptions = {
                headerType: '',
                titleInHeader: true,
                showIcon: false,
                textAlign: 'text-left'
            };

            dialog.showAlert(new MessageAlert(
                self.selectedQuest.property('name'),
                self.currentCampaignContent.property('terms'),
                null,
                dialogOptions
            ));
        };
    };

    QuestChooserDialog.prototype.chooseQuest = function() {
        var self = this;

        // Set quest and send
        self.questChooser.setQuestAndDispatch(self.selectedQuest().slug).then(function() {
            self.close();
        });
    };

    QuestChooserDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    QuestChooserDialog.prototype.detached = function() {
        this.subscriptions.forEach(function(subscription) {
            subscription.dispose();
        });
        this.subscriptions = [];
    };

    return QuestChooserDialog;
});

